module.exports = __webpack_public_path__ + "static/media/circo2024_rollerskating.402d4d14.webp";